/* eslint-disable prefer-const */
/* eslint-disable prefer-template */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// https://stackoverflow.com/questions/35038884/download-file-from-bytes-in-javascript

export function downloadBlob(data, filename, type) {
  const file = new Blob([data], { type: 'application/' + type });
  const url = URL.createObjectURL(file);
  const hiddenAnchor = document.createElement('a');
  hiddenAnchor.href = url;
  hiddenAnchor.target = '_blank';
  hiddenAnchor.style.display = 'none';
  if (filename) {
    hiddenAnchor.download = filename;
  }
  document.body.appendChild(hiddenAnchor);
  hiddenAnchor.click();
}

export function base64ToArrayBuffer(base64) {
  const binaryString = window.atob(base64);
  const binaryLen = binaryString.length;
  const bytes = new Uint8Array(binaryLen);
  for (let i = 0; i < binaryLen; i += 1) {
    let ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}

export function getFileNameFromContentDisposition(response) {
  let filename = '';
  const disposition = response.headers.get('Content-Disposition');
  if (disposition && disposition.indexOf('attachment') !== -1) {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(disposition);
    if (matches != null && matches[1]) {
      filename = matches[1].replace(/['"]/g, '');
    }
  }
  return filename;
}
